import { downloadBase64 } from '../utils/downloadFiles';

import { api } from './apiInstances';

const postDownloadProvisionReport = async (filters) => {
  try {
    const result = await api.post('/v1/Reportes/provision/excel', filters, {
      headers: {
        Accept: '*/*'
      },
      responseType: 'base64'
    });

    if (result.errorMessage) {
      throw new Error(result.errorMessage);
    } else {
      downloadBase64(result.data, 'ReporteProvision', 'xlsx');

      return {
        success: true,
        data: result
      };
    }
  } catch (e) {
    if (e.result) {
      throw new Error(e.result);
    } else {
      throw new Error(
        e.status === 404
          ? 'No se encontraron datos para el reporte'
          : 'Estamos presentando problemas con el servicio de reportes, por favor intente más tarde'
      );
    }
  }
};

export default postDownloadProvisionReport;
